export function datepicker() {
}

datepicker.prototype.init = function (params) {
	let template =
		"<input type='text' id='ag-grid-date-picker-filter' data-input />";

	this.params = params;

	this.eGui = document.createElement('div');
	this.eGui.classList.add('ag-input-text-wrapper', 'custom-date-filter', 'fas');
	this.eGui.innerHTML = template;
	this.eInput = this.eGui.querySelector('input');
	this.eClear = this.eGui.querySelector('a');
	this.picker = $(this.eInput).kendoDatePicker({
		culture: 'cs-CZ',
		format: "dd.MM.yyyy",
		change: this.onDateChanged.bind(this),
	}).data("kendoDatePicker");

};

datepicker.prototype.getGui = function () {
	return this.eGui;
};

datepicker.prototype.onDateChanged = function (date) {
	this.date = (date != null) ? new Date(this.picker.value()) : null;
	this.params.onDateChanged();
};

datepicker.prototype.getDate = function () {
	return this.date;
};

datepicker.prototype.setDate = function (date) {
	if (moment(date).format('YYYY-M-D') !== '1970-1-1') {
		this.picker.value(date);
		this.date = date;
	}
};

window.datepickerComponent = datepicker

export function getDatePicker() {
	// function to act as a class
	function Datepicker() {
	}

	// gets called once before the renderer is used
	Datepicker.prototype.init = function (params) {
		let template =
			"<input type='text' data-input />";

		// create the cell
		this.eGui = document.createElement('div');
		this.eGui.classList.add('ag-datepicker-text-wrapper', 'custom-date-filter', 'fas');
		this.eGui.innerHTML = template;
		this.eInput = this.eGui.querySelector('input');

		let d = new Date(params.value);
		if (params.value != null) {
			this.eInput.value = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
		}

		let inp = this.eInput;

		this.picker = $(inp).kendoDatePicker({
			culture: 'cs-CZ',
			format: "dd.MM.yyyy",
		}).data("kendoDatePicker");

	};

	// gets called once when grid ready to insert the element
	Datepicker.prototype.getGui = function () {
		let picker = this.picker;
		window.setTimeout(function () {
			picker.open();
		}, 250);
		return this.eGui;
	};

	// focus and select can be done after the gui is attached
	Datepicker.prototype.afterGuiAttached = function () {
		this.eInput.focus();
		this.eInput.select();
	};

	// returns the new value after editing
	Datepicker.prototype.getValue = function () {
		return this.eInput.value;
	};

	// any cleanup we need to be done here
	Datepicker.prototype.destroy = function () {
		// but this example is simple, no cleanup, we could
		// even leave this method out as it's optional
	};

	// if true, then this editor will appear in a popup
	Datepicker.prototype.isPopup = function () {
		// and we could leave this method out also, false is the default
		return false;
	};

	return Datepicker;
}

window.getDatePicker = getDatePicker